import { Injectable, inject } from '@angular/core';
import { ActiveToast, IndividualConfig, ToastrService } from 'ngx-toastr';
import { ToastPayload } from '../interfaces/toast.interface';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private toastrService = inject(ToastrService);

  /** show toast */
  show<T>(
    message?: string,
    title?: string,
    override?: Partial<IndividualConfig>,
    type?: string
  ): ActiveToast<T> {
    return this.toastrService.show(message, title, override, type);
  }
  /** show successful toast */
  success<T>(
    message?: string,
    title?: string,
    override?: Partial<IndividualConfig>
  ): ActiveToast<T> {
    return this.toastrService.success(message, title, override);
  }
  /** show error toast */
  error<T>(message?: string, title?: string, override?: Partial<IndividualConfig>): ActiveToast<T> {
    return this.toastrService.error(message, title, override);
  }
  /** show info toast */
  info<T>(message?: string, title?: string, override?: Partial<IndividualConfig>): ActiveToast<T> {
    return this.toastrService.info(message, title, override);
  }
  /** show warning toast */
  warning<T>(
    message?: string,
    title?: string,
    override?: Partial<IndividualConfig>
  ): ActiveToast<T> {
    return this.toastrService.warning(message, title, override);
  }
  /**
   * Remove all or a single toast by id
   */
  clear(toastId?: number): void {
    this.toastrService.clear(toastId);
  }
  /**
   * Remove and destroy a single toast by id
   */
  remove(toastId: number): boolean {
    return this.toastrService.remove(toastId);
  }

  openCustomToast<T>(
    payloadOverride: ToastPayload,
    override?: Partial<IndividualConfig>,
    type: string = 'toast-info',
    message?: string,
    title?: string
  ): ActiveToast<T> {
    const opts = {
      ...override,
      payload: {
        custom: true,
        ...payloadOverride,
      },
    };
    const inserted = this.toastrService.show(message, title, opts, type);
    return inserted;
  }
}
